{
  "branding": {
    "frontdesk-attribution": "Con tecnologia FrontDesk+",
    "practice-logo": "Logo di {{name}}"
  },
  "validation": {
    "required": "Questo campo è obbligatorio",
    "invalid-url": "Inserisci un URL valido",
    "pin-too-short": "Il PIN deve contenere almeno 4 caratteri",
    "pin-default-rejected": "Il PIN standard 0000 non è consentito. Si prega di assegnare il proprio PIN.",
    "invalid-kim-address": "Please enter a valid KIM address (e.g. praxis@musterpraxis.kim.telematik)."
  },
  "common": {
    "back": "Indietro",
    "next": "Avanti",
    "cancel": "Annulla",
    "confirm": "Conferma",
    "done": "Fatto",
    "retry": "Riprova",
    "clear": "Cancella",
    "close": "Chiudi",
    "verifying": "Verifica...",
    "select": "Seleziona",
    "minutes": "minuti",
    "clock": "",
    "gender": {
      "M": "Maschio",
      "W": "Femmina",
      "D": "Diverso",
      "U": "Sconosciuto"
    },
    "insurance": {
      "GKV": "Legale",
      "PKV": "Privato",
      "SELFPAY": "Pagamento diretto"
    },
    "scroll-up": "Scorri verso l'alto",
    "scroll-down": "Scorri verso il basso"
  },
  "settings": {
    "device-reset": {
      "title": "Reimposta dispositivo",
      "description": "Elimina la connessione allo studio, le impostazioni e il PIN di questo dispositivo.",
      "confirmation": "Sarà necessario configurare nuovamente il dispositivo. La configurazione SOL e i dati dei pazienti in inSuite resteranno invariati.",
      "cancel": "Annulla",
      "confirm": "Reimposta ora"
    },
    "title": "Impostazioni",
    "save": "Salva",
    "save-success": "Impostazioni salvate",
    "save-error": "Impossibile salvare le impostazioni",
    "load-error": "Impossibile caricare le impostazioni",
    "pin": {
      "title": "PIN Richiesto",
      "description": "Inserisci il tuo PIN per accedere alle impostazioni.",
      "error": "PIN errato. Riprova.",
      "backspace": "Cancella l'ultima cifra"
    },
    "connection": {
      "title": "Connessione",
      "description": "Impostazioni di connessione per il server Doc-Cirrus Bridge",
      "bridge-url": "URL Bridge",
      "device-name": "Nome del dispositivo",
      "device-name-placeholder": "ad es. Reception, Sala 1, Chiosco",
      "device-name-hint": "Nome per l'identificazione nel dashboard Bridge",
      "kim-address": "Indirizzo KIM (opzionale)",
      "kim-address-placeholder": "praxis@musterpraxis.kim.telematik",
      "kim-address-hint": "This device only. Leave empty to use the practice KIM address.",
      "test": "Test",
      "success": "Connessione riuscita",
      "error": "Connessione fallita",
      "api-unreachable": "API DocCirrus non raggiungibile",
      "status-title": "Stato della connessione",
      "status": {
        "api": "API connessa",
        "ti": "Infrastruttura telematica",
        "card-reader": "Lettore di carte disponibile",
        "medical-card": "Tessera dello studio medico (SMC-B/HBA)"
      },
      "kim-address-consequence": "At Online Check-in the insurer sends the insured person’s data to this address instead of the practice address.",
      "kim-address-practice": "Practice address",
      "kim-address-confirm-title": "Change the KIM address for this device?",
      "kim-address-confirm-description": "At Online Check-in the insurer will send the insured person’s data to this address from now on.",
      "kim-address-confirm-previous": "Current",
      "kim-address-confirm-next": "New",
      "kim-address-confirm-cancel": "Cancel",
      "kim-address-confirm-accept": "Change address",
      "sol-token": "Token Sol (da inSuite)",
      "sol-token-hint": "Copiarlo dalla gestione Bridge in inSuite. Necessario per la connessione.",
      "sol-token-show": "Mostra token",
      "sol-token-hide": "Nascondi token",
      "bridge-unreachable": "Bridge non raggiungibile. Controllare indirizzo e porta.",
      "diagnostic-id": "ID diagnostico: {{id}}",
      "scan-qr": "Scansiona codice QR",
      "scan-title": "Scansiona codice QR del Bridge",
      "scan-manual": "Inserisci manualmente"
    },
    "terminal": {
      "title": "Lettore di carte",
      "description": "Selezione del lettore di carte per l'infrastruttura telematica",
      "select": "Seleziona Terminale",
      "select-placeholder": "Scegli terminale...",
      "loading": "Caricamento terminali...",
      "none-available": "Nessun terminale disponibile",
      "none-found": "Nessun terminale trovato",
      "found": "{{count}} terminale/i trovato/i",
      "connect-hint": "Connettiti prima al server bridge per caricare i terminali.",
      "found-count": "Lettori di schede trovati: {{count}}",
      "refresh": "Ricarica lettori di schede"
    },
    "practice": {
      "title": "Studio medico",
      "description": "Informazioni sul tuo studio medico",
      "name": "Nome dello studio medico",
      "name-placeholder": "es. Dr. Mario Rossi",
      "welcome-message": "Messaggio di Benvenuto",
      "welcome-placeholder": "es. Benvenuti nel nostro studio medico",
      "scheduler-available": "Abilita pianificazione",
      "scheduler-available-description": "Consentire ai pazienti di prenotare gli appuntamenti tramite il terminale self-service",
      "prescription-available": "Abilita il servizio di prescrizione",
      "prescription-available-description": "Patients can request repeat prescriptions at the self-service terminal. The practice reviews every request.",
      "welcome-hint": "Lasciare vuoto per accogliere i pazienti nella loro lingua. Il vostro testo viene mostrato invariato in tutte le lingue."
    },
    "patient-info": {
      "eyebrow": "Patient information review",
      "description": "Applies practice-wide to every FrontDesk+ terminal and is enforced by the server.",
      "enabled": "Show the review after reading the health card",
      "phone": "Review telephone numbers",
      "email": "Review email addresses",
      "hausarzt": "Review primary physician",
      "selection-required": "Select at least one item to review.",
      "save": "Save review setting",
      "saved": "Review settings saved.",
      "conflict": "The setting changed in the meantime. The current version has been loaded.",
      "save-error": "The review settings could not be saved.",
      "unavailable": "The practice-wide setting is currently unavailable.",
      "scope": "Practice-wide · Server",
      "scope-description": "Stored on the practice server and enforced for all terminals.",
      "sentence-off": "The review is switched off. Patients are not asked about their contact details at the terminal.",
      "last-saved": "Last saved on the server: {{value}}",
      "never-saved": "Never saved on the server.",
      "last-saved-all": "Salvato per tutti i dispositivi il {{value}}",
      "never-saved-default": "Impostazione predefinita, non ancora modificata."
    },
    "anamnesis": {
      "title": "Storia medica digitale",
      "description": "Mostra un collegamento e QR code al tuo fornitore di anamnesi dopo il check-in.",
      "enabled": "Mostra il collegamento all'anamnesi dopo il check-in",
      "enabled-description": "Mostra un collegamento e QR code al tuo fornitore di storia medica dopo un check-in completato, ad esempio Nelly.",
      "url": "Collegamento al fornitore di anamnesi",
      "url-hint": "Il collegamento è statico e identico per tutti i pazienti.",
      "preview-label": "Anteprima della schermata di completamento",
      "preview-note": "Il collegamento è statico e identico per tutti i pazienti.",
      "url-first": "Per attivarlo, inserire prima un link valido."
    },
    "appearance": {
      "title": "Aspetto",
      "description": "Personalizza l'interfaccia utente",
      "language": "Lingua",
      "default-kiosk-language": "Lingua paziente predefinita",
      "default-kiosk-language-hint": "Lingua con cui iniziano le nuove sessioni del chiosco per i pazienti.",
      "voice-over-volume": "Volume della voce fuori campo",
      "voice-over-hint": "Controlla il volume dell'assistente vocale per l'accessibilità.",
      "language-first": "Mostra la scelta della lingua all’inizio della sessione"
    },
    "security": {
      "title": "Sicurezza",
      "description": "PIN per accedere alle impostazioni",
      "pin": "PIN",
      "pin-hint": "4-8 digits. At least 4 digits, and not 0000."
    },
    "eyebrow": "Gestione del chiosco",
    "nav": {
      "general": "Generale",
      "flows": "Funzioni",
      "anamnese": "Anamnesi digitale",
      "device": "Dispositivo e connessione"
    },
    "flows": {
      "title": "Funzioni sul terminale"
    },
    "language": {
      "title": "Lingua e voce",
      "description": "Lingua e lettura ad alta voce per i pazienti su questo dispositivo."
    }
  },
  "self-service": {
    "title": "Self-Service",
    "step-progress": "Passo {{current}} / {{total}}",
    "flows": {
      "checkin": "Check-in",
      "scheduler": "Prenota Appuntamento",
      "prescription": "Prescrizioni",
      "locations": "Mappa della Sede",
      "emergency": "Emergenza"
    },
    "audio-guide": {
      "on": "Audio attivo",
      "off": "Audio disattivo",
      "replay": "Ripeti le istruzioni",
      "replay-unavailable": "Nessuna istruzione vocale da ripetere"
    },
    "language-selector": {
      "title": "Seleziona lingua",
      "description": "Seleziona la tua lingua preferita"
    },
    "settings": "Impostazioni",
    "start": {
      "welcome": "Benvenuto",
      "subtitle": "Seleziona un'opzione",
      "check-in-label": "Percorso principale",
      "check-in-cta": "Check-in",
      "check-in-description": "Hai già un appuntamento? Registrati qui.",
      "check-in-hint": "Tieni pronta la tua carta",
      "scheduler-label": "Nuovo",
      "scheduler-cta": "Prenota Appuntamento",
      "scheduler-description": "Programma un nuovo appuntamento.",
      "location-plan": "Mappa della Sede",
      "location-plan-description": "Trova la strada per la sala di trattamento.",
      "prescription-label": "Prescrizione",
      "prescription-cta": "Prescrizioni e ordinazioni",
      "prescription-description": "Visualizza le prescrizioni o ordina le ricariche.",
      "emergency-cta": "Allarme di emergenza locale",
      "emergency-description": "Suona solo su questo dispositivo e non chiama aiuto.",
      "tap-to-start": "Tocca per iniziare"
    },
    "offline": {
      "banner-title": "Check-in temporaneamente non disponibile",
      "banner-message": "Si prega di parlare con il personale della reception per ricevere assistenza.",
      "emergency-available": "L’allarme locale resta disponibile. Non chiama aiuto.",
      "flow-disabled": "Temporaneamente non disponibile"
    },
    "readability": {
      "toggle-label": "Modalità di lettura",
      "on": "Modalità di lettura",
      "off": "Modalità di lettura"
    },
    "reset-overlay": {
      "timeout-title": "La sessione è terminata",
      "timeout-subtitle": "Il tuo tempo è scaduto. I tuoi dati sono al sicuro.",
      "offline-title": "Connessione persa",
      "offline-subtitle": "La connessione è stata interrotta. Si prega di parlare con il personale della reception.",
      "interruption-title": "La sessione è terminata",
      "interruption-subtitle": "La tua sessione è stata terminata in modo sicuro.",
      "completion-title": "Grazie!",
      "completion-subtitle": "La tua richiesta è stata completata con successo.",
      "reassurance": "I tuoi dati personali non vengono memorizzati su questo dispositivo.",
      "auto-dismiss": "Ritorno all'inizio tra {{seconds}} secondi...",
      "dismiss": "Vai all'inizio"
    },
    "timed-terminal": {
      "countdown": "Ritorno automatico in {{seconds}} secondi",
      "countdown-outcome": "Questo terminale tornerà automaticamente alla schermata iniziale.",
      "more-time": "Più tempo",
      "extended": "Tempo prolungato"
    },
    "scheduler": {
      "questionnaire": {
        "language-unavailable": "Queste domande non sono disponibili nella sua lingua. Scelga una delle lingue proposte oppure si rivolga alla reception.",
        "alternatives": "Appuntamenti alternativi",
        "loading": "Caricamento delle domande…",
        "reception-fallback": "Si rivolga alla reception.",
        "error-title": "Impossibile caricare le domande",
        "language-unavailable-lead": "Queste domande non sono disponibili nella sua lingua.",
        "language-unavailable-title": "Scelga una di queste lingue",
        "language-unavailable-body": "Oppure si faccia aiutare alla reception."
      },
      "start": {
        "title": "Prenota Appuntamento",
        "subtitle": "Prenota il tuo appuntamento preferito in pochi passi",
        "welcome": "Benvenuto alla Prenotazione Appuntamenti",
        "description": "Ti guideremo attraverso il processo di prenotazione",
        "cta": "Prenota appuntamento ora"
      },
      "patient-id": {
        "title": "Identificazione",
        "subtitle": "Identificati",
        "mode-card": "Con tessera",
        "mode-search": "Cerca",
        "mode-create": "Crea nuovo",
        "insert-card": "Inserisci la tua tessera sanitaria",
        "reading-card": "Lettura tessera...",
        "simulate-card": "Simula tessera",
        "multiple-matches": "Trovati più pazienti. Utilizzo dati della tessera.",
        "search-placeholder": "Nome o numero assicurazione...",
        "searching": "Ricerca...",
        "no-results": "Nessun risultato trovato",
        "first-name": "Nome",
        "last-name": "Cognome",
        "dob": "Data di nascita",
        "insurance": "Assicurazione",
        "continue": "Continua",
        "creating": "Creazione paziente...",
        "patient-created": "Paziente creato con successo!",
        "create-error": "Impossibile creare il paziente."
      },
      "appointment-type": {
        "title": "Seleziona Tipo di Appuntamento",
        "subtitle": "Seleziona il motivo della tua visita",
        "loading": "Caricamento tipi di appuntamento...",
        "no-types": "Nessun tipo di appuntamento disponibile",
        "error": "Impossibile caricare i tipi di appuntamento. Riprova.",
        "no-bookable": "Questi tipi di appuntamento non possono essere prenotati al chiosco in questo momento. Rivolgiti alla reception o prenota telefonicamente.",
        "disabled-default": "Prenota questo appuntamento direttamente alla reception o telefonicamente.",
        "disabled-footer": "Solo reception/telefono",
        "lead": "Che tipo di appuntamento desidera prenotare?",
        "duration": "ca. {{minutes}} minuti",
        "empty-title": "Al momento qui non è possibile prenotare appuntamenti",
        "none-bookable-title": "Questi appuntamenti non si possono prenotare qui",
        "none-bookable-body": "Chieda alla reception o ci chiami."
      },
      "types": {
        "general": "Consulto Generale",
        "general-desc": "Per disturbi e domande generali",
        "checkup": "Controllo Preventivo",
        "checkup-desc": "Controlli sanitari regolari",
        "vaccination": "Vaccinazione",
        "vaccination-desc": "Programma una vaccinazione",
        "followup": "Follow-up",
        "followup-desc": "Appuntamento di controllo",
        "prescription": "Prescrizione",
        "prescription-desc": "Ritiro prescrizione"
      },
      "slot-selection": {
        "title": "Seleziona Appuntamento",
        "subtitle": "Seleziona un appuntamento disponibile",
        "loading": "Caricamento appuntamenti disponibili...",
        "no-slots": "Nessun appuntamento disponibile",
        "no-appointment-type": "Nessun tipo di appuntamento selezionato",
        "error": "Impossibile caricare gli slot disponibili. Riprova.",
        "quick-select": "Prossimi appuntamenti disponibili:",
        "select-date": "Oppure seleziona una data:",
        "times-for": "{{date}}",
        "available": "Disponibile",
        "unavailable": "Nessuno slot",
        "slots": "slot",
        "select-time-hint": "Tocca un orario per prenotare il tuo appuntamento",
        "week-short": "Sett",
        "weekday-mon": "Lun",
        "weekday-tue": "Mar",
        "weekday-wed": "Mer",
        "weekday-thu": "Gio",
        "weekday-fri": "Ven",
        "weekday-sat": "Sab",
        "weekday-sun": "Dom",
        "period-morning": "Mattina",
        "period-midday": "Mezzogiorno",
        "period-afternoon": "Pomeriggio",
        "period-evening": "Sera",
        "period-morning-short": "Matt.",
        "period-midday-short": "Mezz.",
        "period-afternoon-short": "Pom.",
        "period-evening-short": "Sera",
        "period-dots-legend": "Disponibilità oraria",
        "filter-hint": "Filtra per orari preferiti:",
        "or-choose-below": "oppure scegli qui sotto",
        "no-slots-period": "Niente slot",
        "show-all": "Mostra tutto",
        "free": "gratuito",
        "your-selection": "La tua selezione",
        "oclock": "in punto",
        "choose-slot": "Scegli la fessura",
        "choose-day": "Scegli un giorno",
        "choose-day-first": "Scelga prima un giorno",
        "times-heading": "Orari liberi il {{date}}",
        "time-value": "{{time}}",
        "empty-title": "Nessun appuntamento libero a {{month}}",
        "empty-body": "Guardi il mese successivo o chieda alla reception – la aiutiamo volentieri.",
        "next-month": "Mese successivo",
        "previous-month": "Mese precedente"
      },
      "confirmation": {
        "patient-responses": "Le sue risposte",
        "review-loading": "Verifica del riepilogo…",
        "review-unavailable": "Riepilogo non disponibile. Riprovi o chieda alla reception.",
        "check-booking": "Verifica prenotazione",
        "title": "Conferma Appuntamento",
        "subtitle": "Rivedi la tua prenotazione",
        "patient": "Paziente",
        "datetime": "Data e ora",
        "booking": "Prenotazione...",
        "confirm": "Prenota appuntamento",
        "heading": "Sembra giusto?",
        "lead": "Per favore conferma il tuo appuntamento.",
        "appointment": "Appuntamento",
        "insured-via": "Assicurato attraverso",
        "description-label": "Note per lo studio (facoltativo)",
        "description-hint": "Indichi se dobbiamo tenere conto di qualcosa durante la prenotazione o il check-in.",
        "description-placeholder": "ad es. mobilità ridotta, accompagnatore, note importanti",
        "description-too-long": "Riduca la nota a un massimo di 500 caratteri.",
        "summary": "Sommario",
        "change": "Cambiare",
        "book-binding": "Prenota appuntamento",
        "cancel": "Annulla",
        "type-label": "Tipo di appuntamento",
        "datetime-value": "{{date}} alle {{time}}",
        "name-label": "Nome",
        "insurance-label": "Assicurazione",
        "insurance-GKV": "Assicurazione sanitaria pubblica",
        "insurance-PKV": "Assicurazione sanitaria privata",
        "insurance-SELFPAY": "Pagamento in proprio",
        "change-time": "Modifica appuntamento",
        "description-free-text": "Altre note (facoltativo)",
        "note-wheelchair": "Uso una sedia a rotelle",
        "note-companion": "Vengo accompagnato/a",
        "note-interpreter": "Ho bisogno di un interprete"
      },
      "done": {
        "title": "Appuntamento Prenotato!",
        "label": "Prenotato",
        "subtitle": "Il tuo appuntamento è stato prenotato con successo.",
        "date": "Data",
        "time": "Ora",
        "booking-id": "Numero di prenotazione",
        "qr-hint": "Aggiungi al tuo calendario",
        "qr-description": "Scansiona questo codice QR con la fotocamera del tuo smartphone per aggiungere l'appuntamento alla tua app calendario",
        "auto-redirect": "Verrai reindirizzato alla pagina iniziale a breve...",
        "auto-redirect-countdown": "Ritorno all'inizio tra {{seconds}} secondi...",
        "back-to-start": "Torna all'inizio",
        "print-button": "Stampa promemoria appuntamento",
        "print-preparing": "Preparazione della vista di stampa…",
        "print-error": "Non è stato possibile aprire il promemoria dell’appuntamento. Riprovi o chieda assistenza alla reception.",
        "print-returned": "La vista di stampa del sistema è stata chiusa. Se necessario, può richiedere un’altra copia.",
        "print-title": "Il suo appuntamento",
        "print-location": "Luogo",
        "print-map-hint": "Apri il luogo sul telefono",
        "print-error-v2": "Impossibile aprire il promemoria dell'appuntamento. Riprovi o chieda alla reception."
      },
      "error": {
        "assistance-info": "Non siamo riusciti a confermare la prenotazione. Forse l'appuntamento è già prenotato. Chieda alla reception.",
        "pending-title": "Prenotazione non confermata",
        "pending-info": "Non siamo riusciti a confermare la prenotazione. Forse l'appuntamento è già prenotato. Verifichi di nuovo o chieda alla reception.",
        "title": "Prenotazione Fallita",
        "subtitle": "Non è stato possibile prenotare l'appuntamento.",
        "info": "Riprovi o chieda alla reception."
      },
      "phase": {
        "identify": "Identificarsi",
        "choose": "Scegliere l'orario",
        "confirm": "Confermare"
      }
    },
    "prescription": {
      "start": {
        "title": "Prescrizioni e ordinazioni",
        "subtitle": "Inserisci la tua tessera assicurativa per visualizzare le prescrizioni o ordinare ricariche.",
        "button": "Inserisci la carta"
      },
      "card-check": {
        "loading": "Caricamento del lettore di carte...",
        "no-terminal": "Nessun lettore di carte configurato",
        "no-terminal-hint": "Si prega di contattare il personale per assistenza.",
        "insert-card": "Per favore inserisci la tua carta",
        "insert-card-hint": "Inserite la vostra tessera d'assicurato nel lettore carte.",
        "card-detected": "Carta rilevata",
        "reading": "Scheda di lettura...",
        "reading-hint": "Per favore aspetta un momento.",
        "error": "Errore durante la lettura della carta",
        "retry": "Riprova",
        "manual-lookup": "Continuare senza tessera",
        "load-error": "Impossibile caricare il lettore di carte",
        "read-error": "Non è stato possibile leggere la carta"
      },
      "patient-selection": {
        "title": "Seleziona paziente",
        "subtitle": "Sono stati trovati più pazienti. Seleziona il tuo nome.",
        "try-again": "Riprova",
        "try-again-hint": "Inserire nuovamente la carta"
      },
      "list": {
        "title": "Le tue prescrizioni",
        "for-patient": "Prescrizioni per {{name}}",
        "loading": "Caricamento prescrizioni...",
        "error-title": "Errore di caricamento",
        "fetch-error": "Impossibile caricare le prescrizioni",
        "back-home": "Torna all'inizio",
        "done": "Fatto"
      },
      "detail": {
        "prescription-info": "Informazioni sulla prescrizione",
        "date": "Data",
        "prescriber": "Prescrittore",
        "comment": "Nota",
        "medications": "Farmaci",
        "form": "Modulo",
        "pack-size": "Dimensioni della confezione",
        "manufacturer": "Produttore",
        "loading": "Caricamento prescrizione...",
        "fetch-error": "Impossibile caricare i dettagli della prescrizione",
        "back-to-list": "Torna alla lista",
        "print": "Stampa"
      },
      "types": {
        "public": "Prescrizione pubblica",
        "private": "Prescrizione privata",
        "long-term": "Prescrizione a lungo termine",
        "btm": "Prescrizione di stupefacenti",
        "g": "Prescrizione verde",
        "t": "T-Prescrizione"
      },
      "no-patient": {
        "title": "Paziente non trovato",
        "subtitle": "Sfortunatamente non è stato trovato nessun paziente per questa scheda. Si prega di contattare il personale per assistenza.",
        "try-again": "Riprova",
        "back-home": "Torna all'inizio",
        "title-v2": "Nessun dato corrispondente",
        "subtitle-v2": "Non siamo riusciti a trovarla. Riprovi o chieda alla reception."
      },
      "done": {
        "title": "Grazie",
        "subtitle": "Puoi sederti adesso. Se avete domande, contattate il personale.",
        "no-prescriptions-title": "Nessuna prescrizione in archivio",
        "no-prescriptions-subtitle": "Non siamo riusciti a trovare alcuna prescrizione attiva per te. Se ne aspettavate uno, contattate il personale della reception.",
        "error-title": "Si è verificato un errore",
        "error-subtitle": "Si prega di contattare il personale per ulteriore assistenza.",
        "auto-redirect": "Reindirizzamento automatico in {{seconds}} secondi",
        "finish": "Torna all'inizio"
      },
      "hub": {
        "title": "Le tue prescrizioni",
        "for-patient": "Prescrizioni per {{name}}",
        "loading": "Caricamento prescrizioni...",
        "error-title": "Errore di caricamento",
        "fetch-error": "Impossibile caricare le prescrizioni",
        "back-home": "Torna all'inizio",
        "done": "Fatto",
        "order-button": "Ordinare la prescrizione",
        "existing-prescriptions": "Le tue prescrizioni attuali",
        "no-prescriptions": "Nessuna prescrizione attiva trovata."
      },
      "patient-lookup": {
        "title": "Trova paziente",
        "subtitle": "Inserisci il tuo nome e la data di nascita.",
        "last-name": "Cognome",
        "first-name": "Nome",
        "date-of-birth": "Data di nascita",
        "lastname": "Cognome",
        "lastname-placeholder": "Il tuo cognome",
        "firstname": "Nome",
        "firstname-placeholder": "Il tuo nome",
        "dob": "Data di nascita",
        "search": "Cerca",
        "searching": "Ricerca...",
        "search-error": "Errore di ricerca: {{message}}",
        "no-match": "Nessun paziente trovato. Per favore controlla le tue informazioni.",
        "error": "Errore di ricerca. Per favore riprova.",
        "found": "Paziente trovato",
        "confirm": "Conferma",
        "ambiguous": "Partite multiple",
        "ambiguous-hint-firstname": "Inserisci anche il tuo nome per affinare la ricerca.",
        "ambiguous-hint-additional": "Controlla i tuoi dati o contatta lo staff.",
        "not-found": "Paziente non trovato",
        "not-found-hint": "Nessun paziente è stato trovato con questi dettagli.",
        "not-found-action": "Riprova"
      },
      "manual-identification": {
        "unverified": "La sua identità non è stata confermata con la tessera sanitaria. Lo studio verificherà i suoi dati e la richiesta prima di elaborarla."
      },
      "medication-selection": {
        "title": "Richiedi una prescrizione",
        "subtitle": "Lo studio medico esamina la tua richiesta. Dopo l'approvazione, l'eRx sarà pronto nella tua app e-prescription.",
        "back": "Indietro",
        "submit": "Continua a rivedere",
        "reason-title": "Perché hai bisogno della prescrizione?",
        "reason-hint": "Aiuta lo studio medico a valutare la tua richiesta.",
        "reason-validation": "Scegli un motivo.",
        "reason-schmerzen": "Dolore",
        "reason-entzuendung": "Infiammazione",
        "reason-nachsorge": "Dopo l'intervento chirurgico/procedura",
        "reason-allergie": "Allergia/reazione",
        "reason-chronisch": "Condizione cronica",
        "reason-anderes": "Qualcos'altro",
        "medications-title": "Quali farmaci?",
        "request-hint": "Descrivi ciò di cui hai bisogno o nomina la prescrizione precedente che desideri rinnovare.",
        "request-placeholder": "ad es. Ibuprofene 600 mg, come l'ultima volta",
        "request-validation": "Descrivi di quale farmaco hai bisogno.",
        "history-title": "Precedenti prescrizioni",
        "history-hint": "Aggiungi una voce per precompilare la tua richiesta.",
        "history-loading": "Caricamento delle prescrizioni precedenti...",
        "history-error": "Impossibile caricare le prescrizioni precedenti.",
        "history-add": "Aggiungi",
        "history-added": "Aggiunto",
        "history-date": "Ultimo: {{date}}",
        "history-request-line": "Rinnova: {{medicationName}}",
        "urgency-title": "Quanto è urgente?",
        "urgency-hint": "Aiuta lo studio medico a stabilire la priorità.",
        "urgency-soon": "Urgente",
        "urgency-soon-meta": "Il più presto possibile",
        "urgency-tomorrow": "Presto",
        "urgency-tomorrow-meta": "Nei prossimi giorni",
        "urgency-week": "Questa settimana",
        "urgency-week-meta": "Nessuna pressione temporale",
        "lead": "Lo studio esamina la sua richiesta. Dopo l'approvazione troverà la sua ricetta elettronica nell'app per ricette elettroniche o sulla tessera sanitaria.",
        "history-hint-v2": "Tocchi una ricetta precedente per riprenderla.",
        "history-retry": "Ricarica"
      },
      "request-review": {
        "title": "Revisione dell'ordine",
        "subtitle": "Si prega di rivedere la richiesta di prescrizione.",
        "request-label": "Farmaco richiesto",
        "selected-medications": "Farmaci selezionati",
        "free-text-medications": "Farmaci aggiuntivi",
        "freetext-label": "Altro",
        "quarterly-warning": "La tua tessera sanitaria non è stata letta in questo trimestre. Lo studio medico potrebbe contattarti.",
        "egk-warning": "La tua tessera sanitaria non è stata letta in questo trimestre. Lo studio medico potrebbe contattarti.",
        "submit": "Invia",
        "submitting": "Invio...",
        "submit-error": "Impossibile inviare la richiesta. Per favore riprova.",
        "back": "Indietro",
        "reason-label": "Motivo",
        "urgency-label": "Urgenza",
        "completion-email-choice": "Desidero ricevere un'e-mail quando lo studio avrà elaborato la mia richiesta.",
        "completion-email-label": "Indirizzo e-mail",
        "completion-email-placeholder": "nome@esempio.it",
        "completion-email-hint": "Solo per questo messaggio una tantum. L'indirizzo non viene salvato nei dati anagrafici.",
        "completion-email-invalid": "Inserire un indirizzo e-mail valido.",
        "egk-proof-required": "Le richieste di prescrizione sono disponibili solo dopo la lettura corretta della tessera assicurativa. Rivolgiti al personale.",
        "title-v2": "Verifica richiesta",
        "completion-email-hint-v2": "L'indirizzo viene usato solo per questo messaggio."
      },
      "confirmation": {
        "title": "Richiesta inviata",
        "subtitle": "La tua richiesta di prescrizione è stata inviata con successo.",
        "success-title": "Richiesta inviata",
        "success-subtitle": "La tua richiesta di prescrizione è stata inviata con successo.",
        "estimated-time": "La tua prescrizione sarà pronta tra circa {{time}}.",
        "info": "Puoi ritirare la tua ricetta in farmacia con la tua tessera assicurativa o con l'app eRezept.",
        "auto-redirect": "Reindirizzamento automatico in {{seconds}} secondi",
        "back-to-start": "Torna all'inizio",
        "handling-label": "Handled by the practice",
        "next-steps": "Lo studio esamina la sua richiesta. Dopo l'approvazione potrà ritirare la ricetta elettronica in farmacia con la tessera sanitaria o l'app per ricette elettroniche."
      },
      "phase": {
        "identify": "Identificarsi",
        "request": "Richiesta",
        "review": "Verificare"
      }
    },
    "check-in": {
      "flow-label": "Check-in",
      "has-appointment": {
        "eyebrow": "Appuntamento",
        "title": "Hai un appuntamento?",
        "subtitle": "Seleziona un'opzione",
        "yes-label": "Sì",
        "yes": "Sì, ho un appuntamento",
        "yes-description": "Voglio registrarmi per il mio appuntamento.",
        "yes-hint": "Percorso più veloce",
        "unsure-label": "Forse",
        "unsure": "Non sono sicuro",
        "unsure-description": "Controlleremo per te.",
        "unsure-hint": "Ti cercheremo",
        "no-label": "No",
        "no": "No, senza appuntamento",
        "no-description": "Non ho un appuntamento.",
        "no-hint": "Entra"
      },
      "card-check": {
        "eyebrow": "Tessera assicurativa",
        "title": "Leggi Tessera Sanitaria",
        "subtitle": "Inserisci la tua tessera sanitaria nel lettore",
        "insert-title": "Inserisca la tessera sanitaria nel lettore.",
        "insert-detail": "Leggiamo i tuoi dati automaticamente: non devi fare nient'altro.",
        "other-ways": "Altri modi",
        "no-card-hint": "Se non hai la tua carta con te in questo momento.",
        "pkv-hint": "Utilizza QR code con la tua app assicurativa.",
        "loading": "Caricamento impostazioni...",
        "no-terminal": "Nessun lettore di tessere configurato. Contatta il personale.",
        "checking": "Controllo tessere...",
        "insert-prompt": "Inserisci la tessera...",
        "card-detected": "Tessera rilevata! Pronta per la lettura.",
        "read-card": "Leggi Tessera",
        "simulate-insert": "Simula tessera",
        "reading": "Lettura tessera...",
        "error": "Impossibile leggere la tessera. Riprova.",
        "read-error": "Impossibile leggere i dati della tessera. Riprova.",
        "settings-error": "Impossibile caricare le impostazioni. Riprova.",
        "no-card-prompt": "Non hai la tessera?",
        "no-card-action": "Ricerca manuale",
        "connection-warning": "Problemi di connessione con il lettore di carte. Per favore aspetta...",
        "pkv-prompt": "Assicurazione privata? Online Check-in",
        "pkv-instruction": "Scansiona questo QR code con la tua app di assicurazione sanitaria privata per trasmettere i tuoi dati in formato digitale.",
        "pkv-continue": "Procedi con la registrazione manuale",
        "unreadable-title": "Card detected, but no insurance data could be read.",
        "unreadable-body": "Please try again or go to the reception desk. You can also check in without your card.",
        "unreadable-help": "Riprovi oppure si registri senza tessera. La reception la aiuta volentieri.",
        "title-pkv": "Registrazione con l'app",
        "title-reading": "Lettura della tessera …",
        "title-unreadable": "Impossibile leggere la tessera",
        "title-no-terminal": "Registrazione senza tessera",
        "no-terminal-body": "Il lettore di tessere al momento non è disponibile. Si registri senza tessera o si rivolga alla reception.",
        "reading-detail": "Lasci la tessera nel lettore. Ci vuole solo un attimo.",
        "other-ways-title": "Altre possibilità",
        "no-card-title": "Registrarsi senza tessera",
        "pkv-prompt-title": "Assicurazione privata?",
        "pkv-prompt-hint": "Registrazione con l'app della sua assicurazione sanitaria privata",
        "pkv-close": "Usare comunque la tessera",
        "pkv-instruction-app": "Apra l'app della sua assicurazione sanitaria privata e scansioni questo codice. I suoi dati ci arrivano direttamente."
      },
      "patient-selection": {
        "title": "Seleziona Paziente",
        "subtitle": "Trovati più pazienti. Seleziona te stesso.",
        "firstname-label": "Il tuo nome",
        "firstname-placeholder": "Inserisci il nome...",
        "confirm-button": "Conferma",
        "no-match": "Nessun paziente corrispondente trovato. Si prega di rivolgersi alla reception per ricevere assistenza.",
        "still-ambiguous": "Rimangono più corrispondenze. Si prega di rivolgersi alla reception per ricevere assistenza.",
        "select-error": "Impossibile identificare il paziente. Per favore riprova.",
        "staff-assist": "Vai alla reception",
        "title-v2": "Una breve domanda",
        "subtitle-v2": "Per sicurezza inserisca il suo nome.",
        "no-match-v2": "Non l'abbiamo trovata con questo nome. Controlli l'ortografia o si rivolga alla reception.",
        "still-ambiguous-v2": "Non siamo ancora riusciti a identificarla con certezza. Si rivolga alla reception.",
        "select-error-v2": "Purtroppo non ha funzionato. Riprovi."
      },
      "card-checkin": {
        "title": "Conferma Check-in",
        "subtitle": "I tuoi dati sono stati letti con successo.",
        "confirm": "Conferma check-in"
      },
      "register-from-card": {
        "title": "Nuova Registrazione",
        "subtitle": "Non sei ancora nel nostro sistema. Vuoi registrarti?",
        "card-data": "Dati della carta",
        "create": "Registrati",
        "create-error": "La registrazione non è riuscita. Riprova o chiedi assistenza al personale.",
        "staff-assist": "Chiama il personale",
        "no-card-data-title": "Nessun dato della carta",
        "no-card-data": "Impossibile leggere i dati dalla tua carta.",
        "insurance-verified": "Assicurazione verificata: {{insurer}}",
        "insurer-missing": "The card does not contain a cost-carrier identifier. Registration via the card is not possible. Please go to the reception desk.",
        "title-v2": "I suoi dati dalla tessera",
        "subtitle-v2": "Controlli i suoi dati. Se qualcosa non è corretto, tocchi «Modifica».",
        "create-v2": "Conferma i dati",
        "create-error-v2": "La registrazione purtroppo non ha funzionato. Riprovi o si rivolga alla reception.",
        "insurer-missing-v2": "Sulla sua tessera manca l'indicazione della cassa malati. Si rivolga alla reception.",
        "edit": "Modifica",
        "name": "Nome",
        "insurer": "Cassa malati"
      },
      "patient-lookup": {
        "title": "Cerca Paziente",
        "subtitle": "Inserisci il tuo nome o numero di assicurazione.",
        "lastname": "Cognome",
        "lastname-placeholder": "Il tuo cognome",
        "dob": "Data di nascita",
        "firstname": "Nome",
        "firstname-placeholder": "Il tuo nome",
        "search": "Cerca",
        "searching": "Ricerca...",
        "search-placeholder": "Nome o numero assicurazione...",
        "results-placeholder": "I risultati della ricerca appariranno qui",
        "found": "Paziente trovato!",
        "confirm-identity": "Conferma di essere il paziente mostrato.",
        "confirm-button": "Quello sono io",
        "ambiguous-firstname": "Sono stati trovati più pazienti. Per favore inserisci il tuo nome.",
        "ambiguous-additional": "Sono stati trovati più pazienti. Si prega di contattare il personale.",
        "disambiguation-hint": "Questo ci aiuta a identificarti chiaramente.",
        "not-found": "Nessun paziente è stato trovato con questi dettagli.",
        "error": "Errore di ricerca: {{message}}",
        "staff-assist": "Chiama il personale",
        "not-found-prompt": "Non trovato?",
        "register-new": "Registra nuovo",
        "not-found-hint": "No patient could be found with these details.",
        "create-new": "Register new patient",
        "dob-placeholder": "DD.MM.YYYY",
        "dob-picker": "Choose date of birth in the calendar",
        "title-v2": "Registrazione senza tessera",
        "subtitle-firstname": "Inserisca anche il suo nome.",
        "ambiguous-firstname-v2": "Ci sono più persone con questo cognome. Inserisca anche il suo nome.",
        "search-again": "Cerca di nuovo",
        "found-v2": "L'abbiamo trovata",
        "found-confirm": "Confermi con «Sono io».",
        "not-found-title": "Non l'abbiamo trovata",
        "not-found-check": "Controlli l'ortografia e la data di nascita. La reception la aiuta volentieri.",
        "not-found-reception": "Controlli l'ortografia e la data di nascita oppure si rivolga alla reception.",
        "ambiguous-additional-v2": "Non siamo riusciti a identificarla con certezza. Si rivolga alla reception.",
        "error-v2": "La ricerca al momento non ha funzionato. Riprovi."
      },
      "checking-in": {
        "title": "Un momento: ti stiamo registrando.",
        "subtitle": "Ti aggiungeremo alla coda dei trattamenti e informeremo il team.",
        "step-insurance": "Assicurazione controllata",
        "step-appointment": "Appuntamento confermato",
        "step-waitlist": "Aggiunta alla lista d'attesa",
        "error": "Il check-in non è riuscito. Per favore riprova.",
        "continue": "Continua comunque",
        "title-v2": "Un momento, per favore",
        "loading": "La stiamo registrando …",
        "subtitle-v2": "La inseriamo nella lista d'attesa e avvisiamo il team.",
        "error-title": "Purtroppo non ha funzionato",
        "error-v2": "Non è stato possibile completare la sua registrazione.",
        "error-body": "Riprovi. Se ancora non funziona, la reception la aiuterà."
      },
      "appointment-selection": {
        "title": "Seleziona appuntamento",
        "subtitle": "Hai diversi appuntamenti oggi. Per favore scegline uno.",
        "checking-in": "Check-in...",
        "time": "{{time}}",
        "error-v2": "La registrazione per questo appuntamento non ha funzionato. Riprovi o si rivolga alla reception."
      },
      "no-appointment": {
        "title": "Nessun appuntamento trovato",
        "subtitle": "Non siamo riusciti a trovare un appuntamento per te oggi. Si prega di prenotare un appuntamento regolare.",
        "book-appointment": "Prenota appuntamento",
        "book-appointment-description": "Prenota un nuovo appuntamento tramite il programmatore regolare.",
        "staff-assist": "Chiama il personale",
        "staff-assist-description": "Ho bisogno di assistenza.",
        "booking-disabled": "Appointment booking is currently unavailable",
        "booking-disabled-description": "Please contact the practice team to arrange an appointment.",
        "back-to-start": "Back to start",
        "subtitle-v2": "Oggi non abbiamo trovato nessun appuntamento per lei.",
        "book-v2": "Prendere un nuovo appuntamento",
        "book-v2-description": "Scelga ora un orario libero.",
        "have-appointment": "Ho un appuntamento",
        "have-appointment-description": "La reception la aiuta volentieri.",
        "unavailable-title": "Gli appuntamenti si prenotano alla reception",
        "subtitle-unavailable": "Oggi non abbiamo trovato nessun appuntamento per lei. Si rivolga alla reception."
      },
      "staff-assist": {
        "title": "Il personale è stato informato",
        "subtitle": "Un membro dello staff ti assisterà a breve.",
        "message": "Per favore aspetta qui. Un membro dello staff sarà da te a breve.",
        "start-over": "Torniamo all'inizio",
        "auto-redirect": "Ritorno all'inizio tra {{seconds}} secondi..."
      },
      "eeb-prompt": {
        "title": "Verifica Assicurazione",
        "title-failed": "Verifica Fallita",
        "subtitle": "Come vuoi verificare la tua assicurazione?",
        "subtitle-failed": "Scansiona il codice QR con la tua app assicurativa per richiedere la verifica.",
        "verify-card": "Verifica elettronicamente",
        "verify-card-description": "Invia una richiesta al tuo fornitore di assicurazione.",
        "select-insurer": "Seleziona assicuratore",
        "select-insurer-description": "Selezione manuale del tuo assicuratore.",
        "skip": "Salta",
        "eyebrow-chip": "Alternativa",
        "eyebrow": "Check-in · prova di assicurazione (eEB)",
        "recommended": "Consigliato",
        "qr-title": "Scansiona con l'app della tua assicurazione",
        "qr-description": "Apri l'app della tua assicurazione sanitaria e scansiona il codice: eEB ci verrà inviato direttamente.",
        "qr-address-label": "Invia a",
        "title-app": "Certificato tramite app",
        "subtitle-app": "La sua cassa malati può anche inviarci il certificato direttamente. Quando ha finito, tocchi «Avanti»."
      },
      "quarterly-check": {
        "title": "Verifica Assicurazione",
        "checking": "Stiamo controllando la tua verifica assicurativa attuale...",
        "error": "Il controllo non può essere eseguito.",
        "title-v2": "La sua assicurazione",
        "checking-v2": "Stiamo verificando la sua assicurazione – un momento, per favore.",
        "error-body": "La sua registrazione è completata. La reception chiarirà con lei la questione dell'assicurazione."
      },
      "insurer-prefilled": {
        "title": "La Tua Assicurazione Sanitaria",
        "subtitle": "Conferma la tua assicurazione per questo trimestre.",
        "your-insurance": "La tua assicurazione",
        "last-read": "Ultima verifica il {{date}}",
        "quarterly-notice": "Per scopi di fatturazione, abbiamo bisogno di una prova assicurativa attuale per questo trimestre.",
        "confirm-button": "Sì, questa è la mia assicurazione",
        "change-button": "Ho un'assicurazione diversa",
        "contact-title": "Richiedi una prova elettronica di copertura",
        "contact-description": "Chiama la tua assicurazione e richiedi una prova elettronica di copertura per:",
        "contact-patient": "Paziente",
        "contact-kim-address": "Indirizzo KIM dello studio medico",
        "contact-phone": "Telefono",
        "question": "È questa la sua cassa malati?",
        "quarterly-notice-v2": "Una volta a trimestre ci serve un certificato della sua cassa malati."
      },
      "insurer-search": {
        "title": "Seleziona Assicurazione Sanitaria",
        "subtitle": "Cerca e seleziona la tua assicurazione sanitaria obbligatoria.",
        "placeholder": "Cerca assicurazione...",
        "hint": "Inserisci almeno 2 caratteri per cercare.",
        "no-results": "Nessuna assicurazione trovata.",
        "no-results-hint": "Controlla l'ortografia o prova una ricerca diversa.",
        "label": "Nome della sua cassa malati",
        "search-error-v2": "La ricerca al momento non ha funzionato. Riprovi.",
        "app-alternative": "Preferisce usare l'app della sua cassa malati?"
      },
      "insurer-contact": {
        "title": "Richiedi prova di assicurazione",
        "subtitle": "Scegli una delle seguenti opzioni.",
        "or": "o",
        "option-eeb-title": "Richiedi elettronicamente",
        "option-eeb-description": "Se sussiste il caso di eccezione previsto dalla legge, dopo il suo consenso può consegnare la richiesta al team dello studio.",
        "option-qr-title": "Scansione con l'app",
        "option-qr-description": "Scansiona QR code con l'app della tua assicurazione.",
        "option-call-title": "Chiama te stesso",
        "option-call-description": "Chiama la tua assicurazione e richiedi un eEB per questo studio medico:",
        "phone": "Telefono",
        "phone-not-available": "Numero di telefono sulla tua tessera d'assicurato",
        "patient-name": "Paziente",
        "practice-kim": "Indirizzo KIM dello studio medico",
        "help-notice": "In caso di problemi rivolgersi alla reception.",
        "submit-eeb-button": "Richiedi ora",
        "contacted-button": "Ho chiamato",
        "contacted-button-countdown": "È l'ora della tua chiamata ({{seconds}}s)",
        "go-to-counter-button": "Vai alla reception",
        "qr-continue-button": "Ho scansionato",
        "qr-continue-button-countdown": "Tempo di scansione ({{seconds}}s)",
        "title-v2": "Certificato della sua cassa malati",
        "subtitle-v2": "Il modo più semplice è con l'app della sua cassa malati.",
        "subtitle-no-app": "Scelga come la sua cassa malati deve inviarci il certificato.",
        "option-eeb-description-v2": "Facciamo noi la richiesta alla sua cassa malati. Per questo ci serve il suo consenso.",
        "call-instruction": "Chiami la sua cassa malati e chieda di inviare il certificato al nostro studio.",
        "call-instruction-practice": "Chiami la sua cassa malati e chieda di inviare il certificato allo studio {{practice}}.",
        "done-button": "Fatto – avanti",
        "done-button-countdown": "Fatto – avanti (ancora {{seconds}} s)"
      },
      "eeb-consent": {
        "title": "Consenso",
        "subtitle": "Abbiamo bisogno del tuo consenso per la verifica elettronica dell'assicurazione.",
        "insurance": "La tua assicurazione",
        "consent-title": "Consenso per la Verifica Elettronica dell'Assicurazione (eEB)",
        "consent-text": "Comprendo che la mia assicurazione sanitaria trasmetterà i miei dati assicurativi (ad es. nome, data di nascita, numero assicurativo) tramite il servizio di comunicazione sicuro KIM allo studio medico {{practiceName}} come prova assicurativa. Acconsento a questa trasmissione. Sono consapevole che posso revocare questo consenso in qualsiasi momento senza compromettere il mio trattamento.",
        "withdrawal-notice": "Puoi revocare questo consenso in qualsiasi momento.",
        "agree-button": "Accetto",
        "decline-button": "Annulla",
        "treatment-notice": "Il tuo trattamento non è influenzato da questo consenso.",
        "load-failed": "The consent details could not be loaded. You can scan the QR code with your insurer app instead.",
        "not-available": "This request is not possible here right now. Please speak to reception.",
        "submit-failed": "Your consent could not be saved. Please try again or speak to reception.",
        "title-v2": "Certificato della sua cassa malati",
        "summary": "La sua cassa malati ci invia il certificato direttamente. Per questo ci serve il suo consenso.",
        "confirm-first": "Confermi prima la dichiarazione."
      },
      "qr-code": {
        "title": "Scansiona con l'app assicurativa",
        "instruction-1": "Apri la tua app assicurativa e scansiona questo codice QR.",
        "instruction-2": "Lo studio medico riceverà quindi automaticamente la tua verifica assicurativa.",
        "practice": "Studio medico: {{name}}",
        "alternative-hint": "Alternativa: Usa la tua app assicurativa",
        "instruction-app": "Apra l'app della sua cassa malati e scansioni questo codice. Il certificato ci arriva direttamente.",
        "staff-line": "Per il team dello studio: {{address}}",
        "staff-line-practice": "Per il team dello studio: {{name}} · {{address}}",
        "alternative-app": "Può richiedere il certificato anche con l'app della sua cassa malati: apra l'app e scansioni questo codice."
      },
      "register-basics": {
        "title": "Informazioni Personali",
        "subtitle": "Inserisci i tuoi dati.",
        "family-name": "Cognome",
        "given-name": "Nome",
        "dob": "Data di nascita",
        "gender": "Genere",
        "insurance-type": "Tipo di assicurazione",
        "insurer-name": "Nome della tua assicurazione",
        "insurer-name-placeholder": "ad es. Debeka, DKV, Allianz...",
        "gender-required": "Scelga un'opzione."
      },
      "register-insurer": {
        "title": "Assicurazione Sanitaria",
        "subtitle": "Seleziona la tua assicurazione sanitaria.",
        "search-placeholder": "Cerca assicurazione..."
      },
      "register-details": {
        "title": "Riepilogo",
        "subtitle": "Rivedi le tue informazioni.",
        "create": "Completa registrazione",
        "missing-data": "Si prega di compilare tutti i campi obbligatori.",
        "create-error": "La registrazione non è riuscita. Per favore riprova.",
        "policy-number": "Numero di polizza (facoltativo)",
        "policy-number-placeholder": "Il tuo numero di polizza",
        "create-v2": "Concludi la registrazione",
        "policy-number-hint": "Trova il numero sulla tessera della sua assicurazione."
      },
      "diff-review": {
        "eyebrow-chip": "Recensione",
        "eyebrow": "Check-in · dati della carta",
        "title": "Confronto Dati",
        "subtitle": "Sono state trovate differenze tra i dati della tua tessera e i nostri registri.",
        "col-current": "Record attuale",
        "col-new": "Nuovo dalla carta",
        "new-badge": "nuovo",
        "field-fallback": "Campo",
        "note": "I dati aggiornati ci aiutano a fatturare correttamente e a raggiungerti in caso di emergenza.",
        "comparison-placeholder": "Il confronto verrà mostrato qui",
        "confirm": "Conferma modifiche",
        "apply-error": "Non è stato possibile applicare i dati. Per favore riprova.",
        "retry": "Riprova",
        "skip": "Continua comunque",
        "no-changes": "Nessuna modifica trovata",
        "title-v2": "I suoi dati sono cambiati",
        "subtitle-v2": "Sulla sua tessera ci sono dati più recenti. Li aggiorniamo?",
        "confirm-v2": "Aggiorna e registrati",
        "keep": "Registrarsi senza modifiche",
        "col-current-v2": "Prima",
        "col-new-v2": "Nuovo dalla tessera",
        "value-yes": "Sì",
        "value-no": "No"
      },
      "insurance-selection": {
        "title": "Tipo di Assicurazione",
        "subtitle": "Seleziona il tuo tipo di assicurazione.",
        "gkv": "Assicurato legalmente",
        "gkv-description": "Membro di un'assicurazione sanitaria obbligatoria.",
        "pkv": "Privato o pagamento diretto",
        "pkv-description": "Assicurato privato o pagamento diretto.",
        "pkv-description-v2": "Assicurazione sanitaria privata, oppure paga lei stesso."
      },
      "eeb-request": {
        "title": "Richiesta registrata",
        "subtitle": "Può completare il check-in. La risposta di {{insurer}} arriverà più tardi allo studio.",
        "verifying": "La sua richiesta è stata accettata per l’elaborazione immediata.",
        "success": "La sua richiesta è stata consegnata in modo sicuro al team dello studio.",
        "error": "La conferma della richiesta non è disponibile.",
        "try-alternative": "Metodo alternativo",
        "kim-load-error": "Impossibile caricare l'indirizzo KIM dello studio medico.",
        "kim-label": "Studio medico · KIM",
        "non-blocking-note": "Questo non conferma ancora la ricezione da parte della sua cassa malattia né il suo stato assicurativo.",
        "auto-continue": "Si prosegue automaticamente tra {{seconds}} secondi.",
        "unavailable-title": "Purtroppo non ha funzionato",
        "unavailable-v2": "Non è stato possibile registrare la sua richiesta alla cassa malati.",
        "unavailable-body": "Può farsi inviare il certificato con l'app della sua cassa malati oppure chiarire alla reception.",
        "use-app": "Con l'app",
        "at-reception": "Chiarire alla reception"
      },
      "self-pay": {
        "title": "Pagamento Diretto",
        "subtitle": "Sarai trattato come paziente a pagamento diretto.",
        "info": "Nota che sarai responsabile dei costi del trattamento.",
        "confirm": "Compreso",
        "title-v2": "Paga lei stesso",
        "subtitle-v2": "Paga lei stesso il trattamento.",
        "insured-after-all": "Sono comunque assicurato"
      },
      "done": {
        "title": "Fatto!",
        "subtitle": "Il tuo check-in è completo.",
        "finish": "Fine",
        "done-label": "Fatto",
        "error-label": "Avviso",
        "eyebrow": "Check-in · completato",
        "queue-label": "Sala d'attesa",
        "queue-title": "Per favore, siediti",
        "queue-meta": "Ti chiameremo personalmente.",
        "success-title": "Check-in riuscito!",
        "success-subtitle": "Prendi posto nella sala d'attesa. Verrai chiamato.",
        "auto-redirect": "Verrai reindirizzato alla pagina iniziale a breve...",
        "auto-redirect-countdown": "Ritorno all'inizio tra {{seconds}} secondi...",
        "card-expired-title": "Tessera scaduta",
        "card-expired-subtitle": "La tua tessera sanitaria è scaduta.",
        "card-expired-info": "Contatta il personale per assistenza.",
        "back-to-start": "Torna all'inizio",
        "anamnesis-title": "Modulo completo di anamnesi medica",
        "anamnesis-description": "Scansiona l'QR code per compilare il modulo della tua anamnesi comodamente sul tuo smartphone.",
        "title-confirm": "Thank you!",
        "subtitle-confirm": "You have confirmed your details. Your check-in is complete — please take a seat in the waiting room.",
        "title-saved": "Thank you!",
        "subtitle-saved": "Your changes have been processed. Reception will get in touch if anything is open. Please take a seat in the waiting room.",
        "title-skip": "Skipped",
        "subtitle-skip": "No problem — your check-in is complete. You can tell reception about changes at any time.",
        "title-v2": "È registrato",
        "card-expired-info-v2": "Si rivolga alla reception."
      },
      "patient-info": {
        "loading": "Loading your contact details …",
        "review": {
          "title": "Review contact details",
          "intro": "Are these details still correct? The review is voluntary — your check-in is already complete.",
          "no-contacts": "No telephone numbers or email addresses are on file.",
          "all-correct": "Everything is correct",
          "skip": "Skip",
          "primary": "Primary",
          "protected": "Reception will review any change to this contact.",
          "reveal": "Show",
          "hide": "Hide",
          "type": {
            "MOBILEPRIV": "Mobile (private)",
            "PHONEPRIV": "Phone (private)",
            "MOBILEJOB": "Mobile (work)",
            "PHONEJOB": "Phone (work)",
            "EMAILPRIV": "Email (private)",
            "EMAILJOB": "Email (work)"
          },
          "save": "Save",
          "save-failed": "Could not save — please speak to reception.",
          "delete": "Delete",
          "undo": "Undo",
          "invalid": "Please check the format.",
          "add": "Add",
          "add-title": "Add a contact",
          "add-type": "Type",
          "add-value": "Enter a value",
          "hausarzt": "Family doctor / GP",
          "hausarzt-placeholder": "Enter a name or practice",
          "hausarzt-reception": "Reception will review any change to this information.",
          "hausarzt-invalid": "Enter no more than 120 characters.",
          "category": {
            "phone": "Phone",
            "email": "Email",
            "hausarzt": "Family doctor"
          },
          "category-empty": "Not on file",
          "primary-tag": "Main contact",
          "protected-chip": "Protected — reception reviews",
          "chip-direct": "Changes: saved directly",
          "chip-reception": "Changes: reception reviews",
          "chip-staged_one": "{{count}} change pending",
          "chip-staged_other": "{{count}} changes pending",
          "chip-will-add": "Will be added",
          "expand-phone_one": "Show {{count}} more number",
          "expand-phone_other": "Show {{count}} more numbers",
          "expand-email_one": "Show {{count}} more address",
          "expand-email_other": "Show {{count}} more addresses",
          "collapse-phone_one": "Hide additional number",
          "collapse-phone_other": "Hide additional numbers",
          "collapse-email_one": "Hide additional address",
          "collapse-email_other": "Hide additional addresses",
          "change": "Change",
          "close": "Close",
          "staged-removal": "Will be removed — value hidden",
          "stage-add": "Add to list",
          "add-more-phone": "Add another number",
          "add-more-email": "Add another address",
          "invalid-phone": "Please enter a valid phone number.",
          "invalid-email": "Please enter a valid email address.",
          "hausarzt-previous": "previously: {{value}}",
          "hausarzt-counter": "{{count}} / 120",
          "balance-total_one": "{{count}} change",
          "balance-total_other": "{{count}} changes",
          "balance-direct": "{{count}} saved directly",
          "balance-reception": "{{count}} reviewed by reception",
          "proposal-open": "Suggest a new address",
          "proposal-placeholder": "Your suggestion",
          "proposal-discard": "Discard",
          "proposal-hint": "Your suggestion goes to reception — the address is not changed immediately.",
          "title-v2": "Controlli i suoi dati",
          "balance-prefix": "Al salvataggio:",
          "balance-direct-v2": "Salvato subito: {{count}}",
          "balance-reception-v2": "Verificato dalla reception: {{count}}",
          "chip-reception-v2": "Le modifiche vengono verificate dalla nostra reception",
          "chip-changed": "Modificato: {{count}}",
          "remove": "Rimuovi",
          "example-email": "p. es. nome@esempio.it",
          "example-phone": "p. es. 333 1234567",
          "intro-v2": "La sua registrazione è completata. Questi dati sono ancora corretti? Il controllo è facoltativo.",
          "auto-hide": "I valori mostrati vengono nascosti di nuovo dopo poco tempo."
        },
        "result": {
          "title": "Result",
          "continue": "Continue",
          "outcome": {
            "updated": "Updated",
            "satisfied": "Was already up to date",
            "task-created": "Sent to reception",
            "not-saved": "Not saved yet",
            "pending-retry": "Not saved yet"
          },
          "retry": "Try again",
          "removed": "Was removed",
          "cleared": "Was cleared",
          "task-note": "Nothing was overwritten — reception will get in touch if needed.",
          "not-saved-note": "Nothing was overwritten. Please speak to reception.",
          "banner-unfinished": "One detail has not been saved yet. You can try again directly on that row.",
          "banner-done": "Your details have been processed.",
          "footer": "All other details remain unchanged.",
          "task-note-v2": "Abbiamo trasmesso questo dato alla reception.",
          "banner-done-v2": "Grazie! Abbiamo ricevuto i suoi dati.",
          "footer-v2": "Tutti gli altri dati restano invariati."
        },
        "expiry": {
          "notice": "For data protection reasons the review ends in 2 minutes. Your check-in stays complete.",
          "title": "The review has expired",
          "body": "For data protection reasons all displayed and entered values were deleted. Your check-in is still complete — you do not need to repeat anything. You can tell reception about changes at any time.",
          "continue": "To the summary",
          "body-v2": "Per motivi di privacy abbiamo chiuso la visualizzazione. La sua registrazione è comunque completata. Può comunicare modifiche alla reception in qualsiasi momento."
        }
      },
      "progress": {
        "identify": "Registrarsi",
        "insurance": "Assicurazione",
        "done": "Fatto"
      },
      "dob-format-hint": "Per esempio 01.10.1980",
      "dob-required": "Inserisca la sua data di nascita.",
      "insurance-label": {
        "GKV": "Assicurazione obbligatoria",
        "PKV": "Assicurazione privata",
        "SELFPAY": "Pagamento in proprio"
      }
    },
    "emergency": {
      "title": "Emergenza acuta!",
      "label": "Emergenza",
      "subtitle": "Questo allarme è udibile solo localmente e non ha chiamato aiuto. Per emergenze acute o potenzialmente letali, chiama il 112.",
      "call-emergency": "Chiama i servizi di emergenza (112)",
      "stop-sound": "Interrompe il suono",
      "play-sound": "Riproduci il suono",
      "back-to-start": "Torniamo all'inizio",
      "headline": "Si rivolga subito al personale della reception. In caso di pericolo di vita chiami il 112."
    },
    "help-reception": "Aiuto all'accoglienza",
    "help-reception-toast": "Si prega di contattare la reception. Siamo felici di aiutare",
    "language-entry": {
      "title": "Scegli la lingua"
    },
    "loading": "Caricamento…",
    "step-progress-label": "Avanzamento",
    "step-progress-phase": "Sezione {{current}} di {{total}}: {{phase}}",
    "step-progress-substep": "Parte {{current}} di {{total}}",
    "step-progress-complete": "Completato",
    "identification": {
      "title": "Chi è lei?",
      "lead": "Il modo più rapido è con la tessera sanitaria. Può anche cercare con il suo nome.",
      "lead-card-only": "Inserisca la tessera sanitaria nel lettore di schede.",
      "mode-label": "Come desidera identificarsi?",
      "mode-card": "Con tessera",
      "mode-search": "Cerca per nome",
      "mode-create": "Nuovo paziente",
      "card": {
        "loading": "Preparazione del lettore di schede …",
        "checking": "Verifica del lettore di schede …",
        "insert-title": "Inserisca la tessera sanitaria nel lettore di schede.",
        "insert-detail": "Leggiamo i suoi dati automaticamente.",
        "detected": "Tessera rilevata",
        "read": "Leggi tessera",
        "reading": "Lettura della tessera …",
        "reading-hint": "Lasci la tessera inserita.",
        "no-terminal-title": "Lettore di schede non disponibile",
        "help-with-search": "Cerchi con il suo nome o chieda alla reception.",
        "help-reception": "Chieda alla reception – la aiutiamo volentieri.",
        "unreadable-title": "Tessera rilevata, ma non leggibile",
        "error-title": "Impossibile leggere la tessera",
        "not-unique": "Non siamo riusciti ad associarla con certezza a questa tessera. Cerchi con il suo nome o chieda alla reception.",
        "no-match": "Non abbiamo trovato dati per questa tessera. Cerchi con il suo nome o chieda alla reception.",
        "without-card": "Continua senza tessera"
      },
      "lookup": {
        "lead": "Inserisca il suo cognome e la data di nascita.",
        "first-name": "Nome",
        "last-name": "Cognome",
        "dob": "Data di nascita",
        "dob-hint": "Formato: GG.MM.AAAA",
        "search": "Cerca",
        "confirm": "Sì, sono io",
        "found-title": "L'abbiamo trovata",
        "found-body": "Confermi che si tratta di lei.",
        "first-name-needed-title": "Aggiunga il suo nome",
        "first-name-needed-body": "Così possiamo trovarla con certezza. Poi tocchi «Cerca».",
        "ambiguous-title": "Non siamo riusciti a trovarla con certezza",
        "ambiguous-body": "Chieda alla reception – la aiutiamo volentieri.",
        "not-found-title": "Nessun dato corrispondente",
        "not-found-body": "Controlli i dati inseriti.",
        "error-title": "La ricerca non è possibile al momento",
        "error-body": "Riprovi o chieda alla reception."
      },
      "create": {
        "insurance-question": "Come è assicurato/a?",
        "insurance-required": "Scelga come è assicurato/a.",
        "error-title": "Impossibile salvare i suoi dati",
        "error-body": "Riprovi o chieda alla reception."
      }
    }
  },
  "onboarding": {
    "prepare": {
      "title": "Sblocca prima",
      "subtitle": "FrontDesk+ deve essere attivato nel software del tuo studio.",
      "step1": "Ordina su SolStore (o il tuo partner Doc-Cirrus ordina per te).",
      "step2": "Dopo l'attivazione, attivare in inSuite in \"inSuite Sols\" (diritti di amministratore).",
      "step3": "Apri l'amministrazione Bridge → \"Aggiungi dispositivo\".",
      "cta": "Tutto fatto: vai avanti"
    },
    "welcome": {
      "title": "Aggiungi questo dispositivo allo studio",
      "scan": "Scatta una foto del codice",
      "prepare-link": "Nessun codice in inSuite?",
      "language": "Lingua"
    },
    "scan": {
      "requesting": "È richiesto l'accesso alla telecamera...",
      "scanning": "Punta la fotocamera sul codice",
      "paste": "Incolla invece",
      "manual-title": "Connettiti manualmente",
      "manual-description": "Se il codice QR non è disponibile, prendi i dati di connessione dall'amministrazione Bridge.",
      "address-label": "Indirizzo Bridge",
      "address-placeholder": "https://…/_rest_",
      "soltoken-label": "SOLTOKEN",
      "soltoken-placeholder": "Inserire SOLTOKEN",
      "manual-submit": "Prendi il controllo della connessione",
      "error-title": "Codice non riconosciuto",
      "camera-denied-title": "Accesso alla telecamera negato",
      "camera-denied-hint": "Consenti l'accesso alla fotocamera nelle impostazioni e riprova.",
      "retry": "Riprova"
    },
    "preflight": {
      "title": "Verrà allestito",
      "all-green": "Tutti i test sono stati superati",
      "practice": "Pratica",
      "device-name": "Nome del dispositivo",
      "device-name-placeholder": "per esempio. B. Accoglienza 1",
      "card-reader": "Lettore di carte",
      "pin": "Nuovo numero segreto",
      "pin-placeholder": "PIN di quattro cifre",
      "finish": "Fine",
      "recheck": "Ricontrollare",
      "diagnosis": "Identificazione della diagnosi",
      "checklist-error": "Il Bridge ha rifiutato la connessione o non è raggiungibile. Controlla il SOLTOKEN e l'indirizzo del Bridge.",
      "checklist-retry": "Verifica di nuovo",
      "edit-token": "Modifica SOLTOKEN",
      "rescan": "Scansiona di nuovo il codice"
    },
    "persisting": "Salvataggio della configurazione …",
    "success": {
      "title": "Dispositivo aggiunto",
      "detail": "Il dispositivo è appena apparso sul PC dello studio.",
      "starting": "La modalità paziente sta iniziando..."
    },
    "checklist": {
      "general_api_unavailable": {
        "label": "Collegamento al software dello studio",
        "fix": "Bridge Controllare la connessione e l'indirizzo del server."
      },
      "missing_insuite_url": {
        "label": "Indirizzo inSuite",
        "fix": "Scansiona nuovamente il codice QR: manca l'indirizzo."
      },
      "missing_server_token": {
        "label": "Gettone del server",
        "fix": "Scansiona nuovamente il codice QR: manca il token."
      },
      "missing_gateway_session": {
        "label": "Sessione Gateway",
        "fix": "Accedi di nuovo: la sessione è mancante."
      },
      "missing_gateway_enrollment": {
        "label": "Registrazione del dispositivo",
        "fix": "Registrare il dispositivo su Gateway."
      },
      "gateway_not_ready": {
        "label": "Disponibilità Gateway",
        "fix": "Attendi che Gateway completi la configurazione."
      },
      "token_verification_failed": {
        "label": "Controllo gettone",
        "fix": "Controllare il token del server o la connessione Bridge."
      },
      "session_expired": {
        "label": "incontro",
        "fix": "La sessione è scaduta: accedi nuovamente."
      },
      "device_revoked": {
        "label": "Stato del dispositivo",
        "fix": "Questo dispositivo è stato bloccato. Contatta lo studio."
      },
      "missing_practice_name": {
        "label": "Nome della pratica",
        "fix": "Impossibile caricare il nome dello studio medico (inSuite)."
      },
      "missing_device_name": {
        "label": "Nome del dispositivo",
        "fix": "Inserisci il nome del dispositivo."
      },
      "telematik_unavailable": {
        "label": "Infrastruttura telematica",
        "fix": "Facoltativo: il controllo della carta resta possibile non appena il TI è disponibile."
      },
      "selected_card_reader_unavailable": {
        "label": "Lettore di carte",
        "fix": "Facoltativo: seleziona o collega un lettore di carte."
      },
      "medical_card_unavailable": {
        "label": "SMC-B / HBA",
        "fix": "Facoltativo: inserire la tessera credenziale dello studio medico (SMC-B)."
      }
    },
    "token": {
      "title": "Inserire il SOLTOKEN",
      "description": "Per motivi di sicurezza il codice QR non contiene il SOLTOKEN. Copialo in inSuite alla voce «Sol-Aktivierung» (FrontDesk+) e incollalo qui.",
      "submit": "Continua",
      "rescan": "Scansiona di nuovo il codice"
    }
  }
}
